import type { DocumentReference } from 'firebase/firestore'
import { collection, query, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'

export const reportBugOrSuggestionCollection = collection(
  firestore,
  'reportBugOrSuggestion',
)

export function getReportBugOrSuggestionActive(company: DocumentReference) {
  return query(
    reportBugOrSuggestionCollection,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'status',
      'in',
      [
        'active',
        'solved',
        'waitingCustomerAnswer',
        'toDo',
        'inProgress',
        'done',
      ],
    ),
  )
}

export function getReportBugOrSuggestionActiveByCitiesActive(company: DocumentReference, cities: string[]) {
  return query(
    reportBugOrSuggestionCollection,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'place.city',
      'in',
      cities,
    ),
    where(
      'status',
      '==',
      'active',
    ),
  )
}

export function getReportBugOrSuggestionActiveByCitiesSolved(company: DocumentReference, cities: string[]) {
  return query(
    reportBugOrSuggestionCollection,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'place.city',
      'in',
      cities,
    ),
    where(
      'status',
      '==',
      'solved',
    ),
  )
}
export function getReportBugOrSuggestionActiveByCitiesWaitingCustomerAnswer(company: DocumentReference, cities: string[]) {
  return query(
    reportBugOrSuggestionCollection,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'place.city',
      'in',
      cities,
    ),
    where(
      'status',
      '==',
      'waitingCustomerAnswer',
    ),
  )
}

export function getReportWithoutCities(company: DocumentReference) {
  return query(
    reportBugOrSuggestionCollection,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'place',
      '==',
      null,
    ),
    where(
      'status',
      'in',
      [
        'active',
        'solved',
        'waitingCustomerAnswer',
      ],
    ),
  )
}
